import {
    ApiExecuterAsync,
    ApiExecuterFactory,
    ApiMethod,
    ApiUtil
} from '@/classes/core/api/import';
import {vsprintf} from 'sprintf-js';

export default class ShopStaff {

    public get(param: any = {}): ApiExecuterAsync {
        let url = ApiUtil.url('/owner/site/shop/staff');
        let request = ApiExecuterFactory.createRequest({
            method: ApiMethod.Get,
            url: url,
            param: param
        });

        return ApiExecuterFactory.createAsync(request);
    }

    public show(id: number | string, param: any = {}): ApiExecuterAsync {
        let url = ApiUtil.url(vsprintf('/owner/site/shop/staff/%s', [id]));
        let request = ApiExecuterFactory.createRequest({
            method: ApiMethod.Get,
            url: url,
            param: param
        });

        return ApiExecuterFactory.createAsync(request);
    }

    public post(param: any = {}): ApiExecuterAsync {
        let url = ApiUtil.url('/owner/site/shop/staff');
        let request = ApiExecuterFactory.createRequest({
            method: ApiMethod.Post,
            url: url,
            param: param
        });

        return ApiExecuterFactory.createAsync(request);
    }

    public put(id: number | string, param: any = {}): ApiExecuterAsync {
        let url = ApiUtil.url(vsprintf('/owner/site/shop/staff/%s', [id]));
        let request = ApiExecuterFactory.createRequest({
            method: ApiMethod.Put,
            url: url,
            param: param
        });

        return ApiExecuterFactory.createAsync(request);
    }

    public patch(id: number | string, param: any = {}): ApiExecuterAsync {
        let url = ApiUtil.url(vsprintf('/owner/site/shop/staff/%s', [id]));
        let request = ApiExecuterFactory.createRequest({
            method: ApiMethod.Patch,
            url: url,
            param: param
        });

        return ApiExecuterFactory.createAsync(request);
    }

    public delete(id: number | string, param: any = {}): ApiExecuterAsync {
        let url = ApiUtil.url(vsprintf('/owner/site/shop/staff/%s', [id]));
        let request = ApiExecuterFactory.createRequest({
            method: ApiMethod.Delete,
            url: url,
            param: param
        });

        return ApiExecuterFactory.createAsync(request);
    }
}
